"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _ProgressView = _interopRequireDefault(require("../presentation/ProgressView"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _class, _ProgressContainer;
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2020 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let ProgressContainer = exports.default = (0, _mobxReact.observer)(_class = (_ProgressContainer = class ProgressContainer extends _react.default.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement(_ProgressView.default, this.props);
  }
}, _ProgressContainer.propTypes = {
  progressText: _propTypes.default.string
}, _ProgressContainer.defaultProps = {
  progressText: ""
}, _ProgressContainer)) || _class;